import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { isSome, renderIf } from 'core/utils';
import { DatePicker } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import { toDateObject } from 'core/utils';

const DatePickerFieldTemplate = function ({ field, t, disabled, style, customFormat, formatPlaceholder, ...otherProps }) {
    // mobx-react-form's field.bind() returns a `label` prop intended for the
    // ARIA label. Kendo v3-5 ignored it; v14 treats it as the trigger for an
    // auto floating-label wrapper that duplicates the label we already render
    // in `.form__group__label` below. Strip it so the Kendo widget doesn't
    // wrap itself in a redundant .k-floating-label-container.
    //
    // mobx-react-form's `placeholder` is the raw form-field config string
    // (a translation key in this codebase). Kendo v3-5 didn't render
    // `placeholder` on DatePicker so it never showed; v14 does render it inside
    // .k-input-inner. Per product, the field must show the date format mask
    // (like the pre-upgrade build), not a placeholder — so strip `placeholder`
    // out of the spread (otherwise the raw key would leak through) and don't
    // forward it to the widget.
    const {value, onChange, label: _ignoredLabel, placeholder: _ignoredPlaceholder, ...otherFieldProps} = field.bind();

    const requiredMark = field.rules && field.rules.indexOf('required') !== -1 ? <span className="validation__mark">*</span> : null;

    const warningClasses = classNames({
        'input--warning': !field.isValid && field.touched && !field.isDirty
    });
    const maxValue = field.rules && field.rules.indexOf('before_or_equal_date') !== -1 ? field.rules.substring(field.rules.indexOf('before_or_equal_date')).split(':')[1] : null;
    
    if(maxValue){
        otherFieldProps.max = new Date(maxValue);
    }

    return (
        <div>
            <div className='form__group__label'>{t(field.label)}{requiredMark}</div>
            
            <DatePicker
                {...otherProps}
                {...otherFieldProps}
                format={customFormat ? customFormat : field.initialSetup.format}
                className={warningClasses}
                value={value ? (value.constructor == Date ? value : toDateObject(value)) : null}
                onChange={onChange}
                disabled={disabled || otherProps.disabled} style={style}
                customFormat={customFormat}
                formatPlaceholder={formatPlaceholder ? formatPlaceholder : null}
            />
            {renderIf(isSome(field.localizedError))(
                <div className="validation__message"> <i className="u-icon u-icon--xsml u-icon--warning u-mar--right--tny"></i>{field.localizedError}</div>
            )}
            
        </div>
    );
};

DatePickerFieldTemplate.propTypes = {
    field: PropTypes.object.isRequired,
    t: PropTypes.any,
    disabled: PropTypes.bool,
    style: PropTypes.any,
    formatPlaceholder: PropTypes.any,
    customFormat: PropTypes.any
};

export default defaultTemplate(DatePickerFieldTemplate);
